/** @module Utilities - Environment Config */

const appConfig = process.env;

/**
 * Check if under development environment
 * @function
 * @return {boolean}
 */
export const isDev = () => appConfig.NODE_ENV === 'development';

/**
 * Get url of the site from configuration
 * @function
 * @return {string}
 */
export const getPublicUrl = () => appConfig.PUBLIC_URL.replace(/\/$/, '');

/**
 * Get API domain from configuration
 * @function
 * @return {string}
 */
export const getApiUrl = () => appConfig.API_URL.replace(/\/$/, '');

/**
 * Get options.js url from configuration
 * @function
 * @return {string}
 */
export const getOptionJsUrl = () => appConfig.OPTIONS_JS_URL.replace(/\/$/, '');
